export function useOverflowScrollWrapper(
  $block: Ref<any>,
) {
  const isMouseMove = ref(false);
  const maxScrollLeft = ref(0);
  const scrollLeftRef = ref(0);
  let startX: number;
  let scrollLeft: number;

  const { isDesktop } = useUiBreakpoints();

  const isBefore = computed(() => scrollLeftRef.value !== 0);
  const isAfter = computed(() => scrollLeftRef.value !== maxScrollLeft.value);

  function mouseDown(e: MouseEvent) {
    if (!$block.value) return;

    isMouseMove.value = false;

    window.addEventListener('mousemove', mouseMove);
    window.addEventListener('mouseup', mouseUp);

    startX = e.pageX - $block.value.offsetLeft;
    scrollLeft = $block.value.scrollLeft;
  }

  async function mouseUp() {
    window.removeEventListener('mousemove', mouseMove);
    window.removeEventListener('mouseup', mouseUp);
  }

  async function mouseMove(e: MouseEvent) {
    e.preventDefault();
    const x = e.pageX - $block.value.offsetLeft;
    const walk = (x - startX);

    // eslint-disable-next-line no-param-reassign
    $block.value.scrollLeft = scrollLeft - walk;
    scrollLeftRef.value = $block.value.scrollLeft;
    await nextTick();

    setTimeout(() => {
      isMouseMove.value = true;
    }, 100);
  }

  onMounted(() => {
    if ($block.value && isDesktop.value) {
      maxScrollLeft.value = $block.value.scrollWidth - $block.value.clientWidth;

      $block.value.addEventListener('mousedown', mouseDown);
    }
  });

  onUnmounted(() => {
    if ($block.value && isDesktop.value) {
      $block.value.removeEventListener('mousedown', mouseDown);
    }
  });

  return {
    isMouseMove,
    isBefore,
    isAfter,
  };
}
